import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["autoFocus", "className", "dataKey", "disabled", "inputMode", "dataSelenium", "isInvalid", "isValid", "name", "onChange", "placeholder", "renderExtraIcons", "style", "type", "value", "displayMode", "onFocus", "onBlur"];
import { forwardRef } from 'react';
import UITextInput from 'UIComponents/input/UITextInput';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { SignupDataInputIcon } from '../views/Forms.styles';
import { DisplayMode } from './DisplayMode';
import { InputStyles } from './TextInput.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const dynamicFontSize = (length, isMobile) => {
  const getFontSizeStyle = size => size && {
    fontSize: size
  };
  const lengthToFontMap = isMobile ? {
    38: 15,
    34: 16,
    33: 17,
    30: 18,
    26: 20
  } : {
    44: 17,
    39: 18,
    37: 19,
    32: 20
  };
  const lengthUpperBracket = Object.keys(lengthToFontMap).map(Number).sort((a, b) => b - a).find(maxLength => length > maxLength);
  if (!lengthUpperBracket) {
    return 0;
  }
  return getFontSizeStyle(lengthToFontMap[lengthUpperBracket]);
};
const TextInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      autoFocus,
      className,
      dataKey,
      disabled,
      inputMode,
      dataSelenium,
      isInvalid,
      isValid,
      name,
      onChange,
      placeholder,
      renderExtraIcons,
      style,
      type,
      value,
      displayMode = DisplayMode.Label,
      onFocus,
      onBlur
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobile
  } = useResponsiveness();
  return /*#__PURE__*/_jsxs(InputStyles, {
    disabled: disabled,
    error: isInvalid,
    id: "emailDivSelector",
    success: isValid,
    children: [/*#__PURE__*/_jsx(UITextInput, Object.assign({
      autoComplete: type === 'password' ? 'new-password' : 'on',
      autoFocus: autoFocus,
      className: className,
      "data-selenium": dataSelenium || dataKey,
      disabled: disabled,
      inputMode: inputMode,
      inputRef: ref,
      name: name
    }, displayMode === DisplayMode.Placeholder ? {
      placeholder
    } : null, {
      style: Object.assign({
        textAlign: 'left'
      }, style, dynamicFontSize(value ? value.length : placeholder.length, isMobile)),
      styled: false,
      type: type,
      value: value,
      onBlur: event => {
        if (onBlur) {
          onBlur(event, dataKey);
        }
      }
      // @ts-expect-error Property 'value' does not exist on type 'EventTarget'.
      ,
      onChange: ({
        target
      }) => onChange(target.value),
      onFocus: onFocus
    }, rest)), renderExtraIcons && /*#__PURE__*/_jsx(SignupDataInputIcon, {
      children: renderExtraIcons()
    })]
  });
});
export default TextInput;